import moment from 'moment';
import _ from 'lodash';

import { AdjustmentEnum } from 'Common/FieldEnum';
import { ItemEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';

import * as types from './types';

const INITIAL_STATE = {
  adjustmentItems: [],
  fetchingAdjustmentItems: false,
  fetchAdjustmentDetailError: null,
  selectedAdjustmentDetail: null,
  fetchingAdjustmentDetail: false,
  adjustmentItemsLoadingError: null,
  submitted: false,
  submitError: null,
  submitting: false,
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SELECTED_ADJUSTMENT_DETAIL:
      const selectedAdjustmentDetail = action.payload;
      if (
        selectedAdjustmentDetail &&
        selectedAdjustmentDetail[AdjustmentEnum.AdjustmentItems] &&
        Array.isArray(selectedAdjustmentDetail[AdjustmentEnum.AdjustmentItems])
      ) {
        selectedAdjustmentDetail[
          AdjustmentEnum.AdjustmentItems
        ] = selectedAdjustmentDetail[AdjustmentEnum.AdjustmentItems].map(
          item => ({
            ...item,
            [ItemEnum.SecQty]: item[ItemEnum.SecQty]
              ? Number(item[ItemEnum.SecQty]).toFixed(4)
              : '',
            [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
              ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
              : '',
            [ItemEnum.EndDate]: item[ItemEnum.EndDate]
              ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
              : '',
          })
        );
      }
      return {
        ...state,
        selectedAdjustmentDetail: selectedAdjustmentDetail,
      };

    case types.CREATE_EDIT_ADJUSTMENT_ITEMS:
      return {
        ...state,
        adjustmentItems: action.payload.map(item => ({
          ...item,
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PriQtyAdj]: null,
          [ItemEnum.SecQtyAdj]: null,
          [ItemEnum.PrepareInHouse]:
            typeof item[ItemEnum.PrepareInHouse] === 'string'
              ? item[ItemEnum.PrepareInHouse]
              : item[ItemEnum.PrepareInHouse]
              ? KitchenItemPrepareInHouseFilterEnum.Yes
              : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };

    case types.VIEW_ADJUSTMENT_ITEMS:
      return {
        ...state,
        adjustmentItems: action.payload.map(item => ({
          ...item,
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
            ? KitchenItemPrepareInHouseFilterEnum.Yes
            : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };

    case types.FETCHING_ADJUSTMENT_DETAIL:
      return {
        ...state,
        fetchingAdjustmentDetail: action.payload,
      };

    case types.FETCHING_ADJUSTMENT_DETAIL_ERROR:
      return {
        ...state,
        fetchAdjustmentDetailError: action.payload,
      };

    case types.ADJUSTMENT_ITEMS_LOADING_ERROR:
      return {
        ...state,
        adjustmentItemsLoadingError: action.payload,
      };

    case types.ADJUSTMENT_LOADING:
      return { ...state, fetchingAdjustmentItems: action.payload };

    case types.ADJUSTMENT_DETAIL_SUBMIT:
      return { ...state, submitted: true };

    case types.SUBMITTING_ADJUSTMENT_DETAIL:
      return { ...state, submitting: action.payload };

    case types.SUBMIT_ADJUSTMENT_DETAIL_ERROR:
      if (action.payload.Status === AdjustmentEnum.Error) {
        let messageBody = '';
        let validationModel = action.payload.ValidateAdjustmentModel;
        _.forEach(validationModel, item => {
          messageBody += `Item Code: ${item.ItemCode} currently has ${
            item.ReserveQty
          } on Reserve.This entry is not allowed! `;
        });
        let errorObj = {
          Title: AdjustmentEnum.Error,
          Message: messageBody,
        };
        return {
          ...state,
          submitError: errorObj,
        };
      }
      return {
        ...state,
        submitError: action.payload,
      };

    case types.CLEAR_ADJUSTMENT_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
        fetchAdjustmentDetailError: null,
        adjustmentItemsLoadingError: null,
      };

    case types.RE_ADJUSTMENT_ITEM_LIST:
      let clone = _.clone(state.adjustmentItems, true);
      let remainedItem = [];
      if (action.payload && action.payload.length) {
        _.forEach(action.payload, item => {
          const index = _.findIndex(clone, function(cloneItem) {
            return item.ItemCode === cloneItem.ItemCode;
          });
          if (index !== -1) {
            remainedItem.push(clone[index]);
            clone.splice(index, 1);
          }
        });
      }
      clone = _.concat(remainedItem, clone);
      return {
        ...state,
        adjustmentItems: clone,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/createEditAdjustment/reducer.js